// extracted by mini-css-extract-plugin
export default {"slider-block":"Dpvd8","slider-block-loader":"oLrb1","image-slider-container":"YQR2N"};